/**
 * Converts time string to minutes for easy comparison
 * @param {string} timeStr - Time in format "9:00AM"
 * @returns {number} - Time in minutes from midnight
 */
export const timeToMinutes = (timeStr) => {
	if (!timeStr) return 0;
	// Extract hour, minute, and AM/PM
	const match = timeStr.match(/^(\d{1,2}):(\d{2})(AM|PM|am|pm)$/);
	if (!match) return 0;

	// eslint-disable-next-line prefer-const
	let [, hour, minute, period] = match;
	hour = parseInt(hour, 10);
	minute = parseInt(minute, 10);

	// Convert to 24-hour format
	if (period.toLowerCase() === 'am' && hour === 12) {
		hour = 0;
	} else if (period.toLowerCase() === 'pm' && hour !== 12) {
		hour += 12;
	}

	return hour * 60 + minute;
};
